module.exports = __webpack_public_path__ + "img/banner2_3_zh.0ccf9668.png";